<div odxLayout="flex" class="buttons-container">
  <ng-content></ng-content>
</div>
